export default "__VITE_ASSET__D4M8u8US__"